import { css } from '@emotion/react';
import { theme } from '@frontend/theme'; // Added import for theme
import { AudioState } from './types';

type ScrubberPropType = Pick<AudioState, 'currentTime' | 'duration' | 'hasError'> & {
  alwaysShowProgressButton?: boolean;
};

export const audioScrubberStyles = ({
  currentTime = 0,
  duration,
  hasError,
  alwaysShowProgressButton,
}: ScrubberPropType) => {
  const THUMB_SIZE = 14;
  let percent = 0;
  if (duration > 0) {
    percent = (currentTime / duration) * 100;
  }
  return [
    duration > 0 && currentTime > 0
      ? css`
          background: linear-gradient(
            to right,
            ${theme.colors.primary50} 0%,
            ${theme.colors.primary50} ${percent}%,
            ${theme.colors.neutral30} ${percent}%,
            ${theme.colors.neutral30} 100%
          );
        `
      : css`
          background: ${theme.colors.neutral30};
        `,
    css`
      -webkit-appearance: none;
      appearance: none;
      border-radius: 4px;
      border: none;
      cursor: pointer;
      height: 5px;
      margin: 0;
      outline: none;
      padding: 0;
      width: 100%;
    `,
    css`
      &:hover {
        &::-webkit-slider-thumb {
          opacity: 1;
        }
      }

      &::-webkit-slider-thumb {
        appearance: none;
        background: ${theme.colors.primary50};
        border-radius: 50%;
        cursor: pointer;
        height: ${THUMB_SIZE}px;
        opacity: ${alwaysShowProgressButton ? 1 : 0};
        transition: opacity 200ms;
        width: ${THUMB_SIZE}px;
      }

      &::-moz-range-thumb {
        background: ${theme.colors.primary50};
        border-radius: 50%;
        cursor: pointer;
        height: ${THUMB_SIZE}px;
        width: ${THUMB_SIZE}px;
        border-color: ${theme.colors.primary50};
      }
    `,
    hasError &&
      css`
        & {
          cursor: default;

          &::-webkit-range-thumb {
            display: none;
          }

          &::-moz-range-thumb {
            display: none;
          }
        }
      `,
  ];
};
